import Vue from 'vue'

const division = {
  state: {
    division: [],
    selectedDivision: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    division(state) {
      return state.division
    },
    selectedDivision(state) {
      return state.selectedDivision
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    division(state, payload) {
      state.division = payload
    },
    selectedDivision(state, payload) {
      state.selectedDivision = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedDivision(context, payload) {
      context.commit('selectedDivision', payload)
    },
    loadDivision(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'Division'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('division', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    refreshSelectedDivision(context, payload) {
      if (context.state.selectedDivision && context.state.selectedDivision.ID) {
        context.dispatch(
          'loadSelectedDivision',
          context.state.selectedDivision.ID
        )
      }
    },
    loadSelectedDivision(context, payload) {
      if (
        context.state.selectedDivision &&
        context.state.selectedDivision.ID != payload
      ) {
        context.commit('selected', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'Division/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedDivision', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadDivision(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadDivision')
      })
    },
    updateDivision(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Division/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'Division updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadDivision')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createDivision(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Division`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'Division created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadDivision')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveDivision(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateDivision', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createDivision', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteDivision(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Division/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'Division deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadDivision')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default division
